import useSWRMutation from 'swr/mutation'
import { fetcher } from '@/services/common'
import type { TypeFetcher } from '@/types/common/fetcher'

export const useSWRMutationFetch = ({
  method,
  url,
  params,
  data,
  headerAppend,
}: TypeFetcher) => {
  const {
    data: result,
    error,
    isMutating,
    trigger,
    reset,
  } = useSWRMutation(
    {
      method,
      url,
      params,
      data,
      headerAppend,
    },
    fetcher,
    { revalidate: false }, // キャッシュの再検証
  )

  return { result, error, isMutating, trigger, reset }
}
